import Messages from "./messages";
import store from "../store/index";
import ApiRequests from "../utils/requests";

const isDevelopment = process.env.NODE_ENV === "development";

export default {
  install(Vue) {
    // Use new Vue instance as an event bus
    const signalr = new Vue();
    // Every component will use this.$signalr to access the event bus
    Vue.prototype.$signalr = signalr;
    // Delay before opening a new stream after the browser gave up
    const delay = store.getters.number("VUE_APP_RETRY_DELAY_MILLIS") || 5000;
    const url = `${ApiRequests.BACKEND_URL}${store.getters.string(
      "VUE_APP_HUB_PATH"
    )}`;

    /**
     * Open an SSE stream and forward its events through $signalr.
     * The browser retries network errors by itself. A new stream is opened
     * here only when the browser closes it (for example after a 401).
     */
    function start() {
      const source = new EventSource(url, { withCredentials: true });

      // The server sends a new connection ID on every (re)connection
      let reconnecting = false;

      source.addEventListener("connected", (e) => {
        reconnecting = false;
        const { connectionId } = JSON.parse(e.data);
        signalr.$emit(Messages.SIGNALR_CONNECTED_MSG, connectionId);
      });

      store.getters.hubs.forEach((msg) => {
        // Forward server side events through $signalr, where components will listen to them
        source.addEventListener(msg.message, (e) => {
          const { topic, body } = JSON.parse(e.data);
          signalr.$emit(msg.mapped, { topic, message: body });
        });
      });

      source.onerror = () => {
        if (source.readyState === EventSource.CONNECTING) {
          // Emit once per outage, like SignalR did
          if (!reconnecting) {
            reconnecting = true;

            if (isDevelopment) {
              console.warn("Connection lost, reconnecting");
            }

            signalr.$emit(Messages.SIGNALR_RECONNECTING_MSG);
          }

          return;
        }

        if (isDevelopment) {
          console.error("Connection closed, opening a new one");
        }

        signalr.$emit(Messages.SIGNALR_DISCONNECTED_MSG);
        setTimeout(start, delay);
      };
    }

    start();
  },
};
